import "core-js/modules/es6.function.name";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config';
import { pests } from '@/api/api_url';
import { getToken, formatYMD } from '@/libs/util';
import { renderFormMixins } from '@/mixins/renderFormMixins';
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import BmCityList from 'vue-baidu-map/components/controls/CityList.vue';
import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation.vue';
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue';
import BmLabel from 'vue-baidu-map/components/overlays/Label.vue';
import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue';
import { dptimetasklist, dptimetaskadd, dptimetaskdel, dptimetaskedit } from '@/api/jingxiaoshang';
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      weekitems: [{
        "name": "周一",
        'value': 1
      }, {
        "name": "周二",
        'value': 2
      }, {
        "name": "周三",
        'value': 3
      }, {
        "name": "周四",
        'value': 4
      }, {
        "name": "周五",
        'value': 5
      }, {
        "name": "周六",
        'value': 6
      }, {
        "name": "周天",
        'value': 7
      }],
      childrenmodal: {
        status: 2,
        week_day: [],
        time: ""
      },
      modal7: false,
      switch1: false,
      formValidate: {
        items: [// {
          //   value: null,
          //   value1: [],
          //   value1List:[],
          //   index: 1,
          //   status: 1
          // }
        ]
      },
      mode2: 1,
      controllist2: [{
        name: "常闭",
        value: 1
      }, {
        name: "常开",
        value: 2
      }],
      controllist: [{
        name: "自动",
        value: 0
      }, {
        name: "常闭",
        value: 1
      }, {
        name: "常开",
        value: 2
      }, {
        name: "定时开关",
        value: 3
      }],
      headers: {
        Authorization: getToken()
      },
      hasDisabled: true,
      formModel: {
        did: "",
        jrm_value: ""
      },
      formRules: {// sampling_value:[{required: true,type:"number", message: '采样频率不能为空', trigger: 'change'}
        //   ],
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {},
    projectCode: {}
  },
  components: {
    BaiduMap: BaiduMap,
    BmGeolocation: BmGeolocation,
    BmCityList: BmCityList,
    BmMarker: BmMarker,
    BmLabel: BmLabel,
    BmLocalSearch: BmLocalSearch
  },
  computed: {
    getAction: function getAction() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + pests.upload_file;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + pests.upload_file;
      } else {
        result = config.baseUrl.alp + "" + pests.upload_file;
      }

      return result;
    }
  },
  methods: {
    switchchange: function switchchange(event, item) {
      var _this = this;

      //  console.log(" item", item) 
      // console.log(" item.week_day", item.week_day)
      // return;
      // console.log("item", item)
      // //did,status,time,week_day,ttid,enable
      // console.log("event", event)
      // return; 
      //  console.log("enable",enable)
      dptimetaskedit({
        "did": this.formModel.did,
        'status': item.status,
        "time": item.time_str,
        'week_day': item.week_day,
        'ttid': item.ttid,
        'enable': event
      }).then(function (res) {
        if (res.result === 0) {
          _this.$Message.success(res.errorMsg);

          _this.on_change(3);
        } else {
          _this.$Message.error(res.errorMsg);
        }
      });
    },
    handleRemove: function handleRemove(ttid) {
      var _this2 = this;

      dptimetaskdel({
        "did": this.formModel.did,
        'ttid': [ttid]
      }).then(function (res) {
        if (res.result === 0) {
          _this2.$Message.success(res.errorMsg);

          _this2.on_change(3);
        } else {
          _this2.$Message.error(res.errorMsg);
        }
      });
    },
    modal7cancel: function modal7cancel() {
      this.modal7 = false;
    },
    //写入计划
    modal7Ok: function modal7Ok() {
      var _this3 = this;

      //this.childrenmodal
      console.log(this.childrenmodal);

      if (this.childrenmodal.time == "") {
        this.$Message.error("时间必须");
        return false;
      }

      dptimetaskadd(_objectSpread({
        "did": this.formModel.did
      }, this.childrenmodal)).then(function (res) {
        if (res.result === 0) {
          _this3.modal7 = false;

          _this3.$Message.success(res.errorMsg);

          _this3.on_change(3);
        } else {
          _this3.$Message.error(res.errorMsg);
        }
      });
    },
    on_change: function on_change(value) {
      var _this4 = this;

      // console.log(event)
      if (value == 3) {
        this.mode2 = 1;
        dptimetasklist({
          "did": this.formModel.did
        }).then(function (res) {
          // debugger
          if (res.result === 0) {
            console.log("res", res);

            if (res.body.total >= 1) {
              for (var index in res.body.ttcmds) {
                var week_str = [];
                res.body.ttcmds[index].status = res.body.ttcmds[index].dpcmd.dps[0].val_int64;

                if (res.body.ttcmds[index].dpcmd.dps[0].val_int64 == 1) {
                  res.body.ttcmds[index].status_str = "常闭";
                } else {
                  res.body.ttcmds[index].status_str = "常开";
                } //仅一次


                if (res.body.ttcmds[index].week_day && res.body.ttcmds[index].week_day.length > 0) {
                  if (!res.body.ttcmds[index].enable) {
                    res.body.ttcmds[index].enable = false;
                  }

                  for (var ii = 0; ii < res.body.ttcmds[index].week_day.length; ii++) {
                    for (var i = 0; i < _this4.weekitems.length; i++) {
                      if (res.body.ttcmds[index].week_day[ii] == _this4.weekitems[i].value) {
                        week_str.push(_this4.weekitems[i].name);
                      }
                    }
                  }
                } else {
                  res.body.ttcmds[index].week_day = [];
                  week_str.push("仅一次");
                }

                var str = week_str.join("、");
                res.body.ttcmds[index].week_str = str; //JSON.stringify(week_str)
              }
            }

            _this4.formValidate.items = res.body.ttcmds;
          } else {
            _this4.formValidate.items = [];

            _this4.$Message.error(res.errorMsg);
          }
        });
      } else {
        this.mode2 = 0;
      }
    },
    handleAdd: function handleAdd() {
      this.modal7 = true; // this.index++;
      // this.formValidate.items.push({
      //   value: '',
      //   value1: [],
      //   value1List:[],
      //   index: this.index,
      //   status: 1
      // });
    }
  },
  mounted: function mounted() {
    //debugger
    if (this.edit) {
      if (this.setData) {
        console.log('a', this.setData); //alert()
        // Object.assign(this.formModel,this.setData)

        this.$set(this.formModel, 'did', this.setData.did);
        this.$set(this.formModel, 'jrm_value', this.setData.jrm_value);

        if (this.setData.jrm_value == 3) {
          this.mode2 = 1;
          this.on_change(3);
        } else {
          this.mode2 = 0;
        } // console.log('b',this.formModel) 

      }
    }
  },
  created: function created() {//this.init()
  }
};